var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-stretch justify-start" },
        [
          _vm.currentUser.team && _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("TeamWidget", {
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA") &&
          _vm.currentUser.team &&
          _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("LastGameWidget", {
                    staticClass: "flex-grow-1",
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.team && _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("NextGameWidget", {
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("LastScoutingAnalysesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("ScoutingTasksWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("UploadedGamesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("CapturePlaylistsWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "elevation-2",
                    attrs: { slides: ["pointsVsXPointsChart"] },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "elevation-2",
                    attrs: { slides: ["playerScoutChart"] },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }